import { ENROLLMENT_COMMON_MESSAGES } from '../../constants/enrollmentContent'
import { getUploadConfig } from '../uploadDocumentConfig'
import type { VisibleUploadDocument } from './types'

export const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024

export function getUploadDocumentsValidationError({
  isLoading,
  isError,
  visibleDocuments,
  isDocumentUploaded
}: {
  isLoading: boolean
  isError: boolean
  visibleDocuments: VisibleUploadDocument[]
  isDocumentUploaded: (document: VisibleUploadDocument) => boolean
}) {
  if (isLoading || isError) {
    return 'Required documents could not be loaded. Please refresh and try again.'
  }

  const missingDocuments = visibleDocuments.filter(document => !isDocumentUploaded(document))

  if (missingDocuments.length === 0) {
    return null
  }

  const missingDocumentTitles = missingDocuments.map(document => getUploadConfig(document).title)
  const missingList = missingDocumentTitles.join(', ')

  return missingDocuments.length === 1
    ? `${missingList} upload is required.`
    : `All visible documents are required. Missing: ${missingList}.`
}

export function getUploadDocumentsErrorMessage(configTitle: string, error: unknown) {
  return error instanceof Error
    ? error.message
    : `Unable to upload ${configTitle} right now. Please try again.`
}

export function getMissingSessionUploadError() {
  return ENROLLMENT_COMMON_MESSAGES.sessionExpired
}
